import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ififowdcasczwlydunfj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlmaWZvd2RjYXNjendseWR1bmZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg4MjI2OTMsImV4cCI6MjA4NDM5ODY5M30.roQugzcisrUqmSRRrNqszQxWtDj2A2FMgDPaYXEg0nM';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
